import { HttpClient } from "@angular/common/http";
import { Component, OnInit, ViewChild } from "@angular/core";
import { FormUtils, IDataTableColumn, IDataTablePaginationOptions, IDataTableSelectionOption, NovoAsideRef, NovoDataTable, NovoModalRef, NovoToastService } from "novo-elements";

interface QueuedItem {
  _id : string,
  title : string,
  description : string,
  company : string,
  refcode : string,
  country : string,
  state : string,
  url : string,
  posteddate : string,
  city : string,
  mesco : string,
  action : string,
  onets: [
      {
          id : number,
          alias : string,
      }
  ],
  sourcerefcode: string,
  imported: boolean,
};

@Component({
  selector: 'queue-modal',
  templateUrl: './queue-modal.component.html',
  styleUrls: ['./queue-modal.component.scss']
})
export class QueueModal implements OnInit {
  @ViewChild('modalTable') table: NovoDataTable<any>;
  
  public paginationOptions: IDataTablePaginationOptions = {
    theme: 'standard',
    pageSize: 10,
    pageSizeOptions: [10, 50, 100, 250, 500],
  };
  public selectionOptions: IDataTableSelectionOption[] = [];

  public selectedRecordId: string = '';

  columns:IDataTableColumn<any>[] = [
    { label: 'Title', id: 'title', sortable: true, filterable: true, type: 'text' },
    { label: 'Company', id: 'company', sortable: true, filterable: true, type: 'text' },
    { label: 'Refcode', id: 'refcode', sortable: true, filterable: true, type: 'text' },
    { label: 'Country', id: 'country', sortable: true, filterable: true, type: 'text' },
    { label: 'State', id: 'state', sortable: true, filterable: true, type: 'text' },
    { label: 'City', id: 'city', sortable: true, filterable: true, type: 'text' },
    { label: 'Url', id: 'url', sortable: true, filterable: true, type: 'link' },
  ]
  

  displayedColumns = [
    'selection',
    'title',
    'company',
    'refcode',
    'country',
    'state',
    'city',
    'url',
  ]

  public queuedItems: QueuedItem[] = [];

  constructor(private ref: NovoAsideRef, private formUtils: FormUtils, private http: HttpClient, private toast: NovoToastService) {}

  ngOnInit(): void {
    this.http.get('/getQueue').subscribe((res:any) => {
      this.queuedItems = res.map((item: any) => ({...item, id: item._id }));
      console.log(res);
    });
  }

  public refresh(): void {
    this.table.state.reset();
  }

  public addToLeadQueue() {
    this.http.post('/moveToLeadQueue', {ids:  Array.from(this.table.state.selectedRows, (v)=>v[0])}).subscribe((res:any) => {
      this.toast.alert({
        title: 'Success',
        message: 'Added to Lead Queue. Leads will be created shortly',
        theme: 'success',
        icon: 'check',
        position: 'growlTopRight',
        hideDelay: 3000,
      });
      this.close();
    });
  }

  public addToCustomObjectQueue() {
    this.http.post('/moveToCOQueue', {ids:  Array.from(this.table.state.selectedRows, (v)=>v[0])}).subscribe((res:any) => {
      this.toast.alert({
        title: 'Success',
        message: 'Added to Lead Queue. Leads will be created shortly',
        theme: 'success',
        icon: 'check',
        position: 'growlTopRight',
        hideDelay: 3000,
      });
      this.close();
    });
  }

  close() {
    this.ref.close();
  }

}